<template>
    <label
        class="radio_custom"
        :for="item.id"
    >
        <input
            class="radio_custom_input"
            type="radio"
            :id="item.id"
            :checked="modelValue === item.value"
            :value="item.value"
            :name="item.name"
            @change.prevent="radioClick()"
        >
        {{ item.label }}
    </label>
</template>
<script>

export default {
    name: "radio_custom",
    props: {
        item: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: [String, Number],
            required: true,
        },
    },
    methods: {
        radioClick() {
            this.$emit('update:modelValue', this.item.value);
        }

    },
}
</script>
